/**
 * ViewModeToggle
 *
 * Segmented "Grid | List" toggle used in the File Management action bar.
 * Mirrors the pattern from `ViewTabsToolbar` (icon + text label, indigo active state).
 */

import { VIEW_MODE_OPTIONS } from "../constants/fileManagement.constants";
import type { ViewModeToggleProps } from "../types/fileManagement.types";

const ViewModeToggle = ({ viewMode, onChange }: ViewModeToggleProps) => {
  return (
    <div className="w-max flex items-center p-0.5 border border-border-gray dark:border-border-gray-dk rounded-md shrink-0">
      {VIEW_MODE_OPTIONS.map(({ id, icon: Icon, label }) => (
        <button
          key={id}
          type="button"
          className={`pl-1 pr-2 py-0.5 cursor-pointer rounded-sm ${
            viewMode === id && "bg-verba-indigo dark:bg-verba-indigo-dk"
          }`}
          onClick={() => onChange(id)}
          title={label}
        >
          <div className="flex items-center gap-0.5">
            <Icon
              className={`w-[18px] h-[18px] ${
                viewMode === id
                  ? "text-pure-white dark:text-pure-white-dk"
                  : "text-verba-indigo dark:text-verba-indigo-dk"
              }`}
            />
            <span
              className={`text-md whitespace-nowrap ${
                viewMode === id
                  ? "font-semibold text-pure-white dark:text-pure-white-dk"
                  : "font-normal text-verba-indigo dark:text-verba-indigo-dk"
              }`}
            >
              {label}
            </span>
          </div>
        </button>
      ))}
    </div>
  );
};

export default ViewModeToggle;
